import { useAtom, useSetAtom } from 'jotai';
import { isSoundEnabledAtom, showSoundContolModalAtom } from '../atom/Atom';

import { HOVER_DOWN_STYLE } from '../constants/Consts';

export const SoundControlButton = () => {
  const [isSoundEnabled, setIsSoundEnabled] = useAtom(isSoundEnabledAtom);
  const setShowSoundContolModal = useSetAtom(showSoundContolModalAtom);

  return (
    <div
      className="z-40 fixed rounded flex items-center justify-center bottom-[1%] right-[1%] cursor-pointer bg-[#FFEEE2] gap-1 px-1 text-xs pc:gap-2 pc:px-2 pc:text-base"
      onClick={() => {
        setShowSoundContolModal(false);
        setIsSoundEnabled(!isSoundEnabled);
      }}
    >
      <span className="text-enable font-bold">サウンド</span>
      <div
        className={`flex items-center rounded my-1 px-1 gap-1 pc:my-2 pc:px-2 pc:gap-2 ${
          isSoundEnabled ? 'bg-enable' : 'bg-disable'
        } ${HOVER_DOWN_STYLE}`}
      >
        <span className="text-white font-bold">{isSoundEnabled ? 'オン' : 'オフ'}</span>
        <img className="w-6 pc:w-10" src={`/common/icons/${isSoundEnabled ? 'sound_on' : 'sound_off'}.webp`} alt={'サウンド'} />
      </div>
    </div>
  );
};
